import List from './List';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'disputed_job_billings',
  inputShow: gql`
    query disputedJobBillings($input: disputedJobBillingInput) {
      disputedJobBillings(input: $input) {
        id
        __typename
      }
    }
  `,
  list: List,
  show: Show,
  options: {
    group: false,
  },
};
